// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import $ from 'jquery'
import 'babel-polyfill'
import store from './store'
import './assets/css/reset.css'
import './assets/css/border.css'
import 'mint-ui/lib/style.css'
import Utile from './assets/js/MapToJsonAndJsonToMap.js'

Vue.config.productionTip = false
Vue.use(Utile)
// import fastClick from 'fastclick'
// fastClick.attach(document.body)

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js